/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Libraries
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import { StatusIndicatorProps } from '../../../../../../layout/elements/StatusIndicator';

export const FeederInterlockContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.crusherDashboard.feederInterlock.borderColor};
  border-radius: 4px;
`;

export const FeederStartContainer = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.feederInterlock.borderColor};
  width: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };
`;

export const CrusherStartListDescription = styled.div<Pick<StatusIndicatorProps, 'status'>>`
  padding: 12px 20px;
  gap: 2px;
  width: 100%;
  background-color: ${({ status, theme }) => (
    status === 'alarm'
      ? theme.color.crusherDashboard.feederInterlock.descriptionListErrorBackgroundColor
      : 'transparent'
  )};
  border-radius: ${({ status }) => (
    status === 'alarm'
      ? '4px'
      : 'none'
  )};
`;

export const GeneralContainer = styled.div`
  padding: 0.75rem 1rem 0 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem 0 1.5rem;
  };
`;

export const GeneralPermissives = styled.div`
  padding: 0 1rem 1rem 1rem;
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.feederInterlock.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };
`;

export const CrusherContainer = styled.div`
  padding: 0.75rem 1rem 0 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem 0 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem 0 1.5rem;
  };
`;

export const CrusherPermissives = styled.div`
  padding: 0 1rem 1rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };
`;

export const ColumnBorderRight = styled(Col)`
  border-right: none;
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.feederInterlock.borderColor};
  padding-bottom: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding-bottom: 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    border-right: 1px solid ${({
      theme,
    }) => theme.color.crusherDashboard.feederInterlock.borderColor};
    border-bottom: none;
    padding-bottom: 0;
  };
`;

export const HydraulicsContainer = styled.div`
  padding: 0.75rem 1rem 0 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem 0 1.5rem;
  };
`;

export const HydraulicsPermissives = styled.div`
  padding: 0 1rem 1rem 1rem;
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.feederInterlock.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    width: calc(100% + 2px);
  };
`;

export const LubricationContainer = styled.div`
  padding: 0.75rem 1rem 0 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem 0 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem 0 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 0;
  };
`;

export const LubricationPermissives = styled.div`
  padding: 0 1rem 1rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 1.5rem 1.5rem 1.5rem;
  };
`;
